import React, { Component } from "react";
import {Link} from "react-router-dom";
import Select from "react-select";
import axios from 'axios';
import DatePicker from 'react-date-picker';



import './Influencer.scss';
import MyContext from '../MyContext.jsx';
import {epochToDate} from '../../assets/js/handy.mjs';

var customer_XHR={'abort' : ()=>{}};

var singleCustomer_DOM;
const imageUrl = '/file-name.jpg';


class Influencer extends Component {
   fileObj = [];
   fileArray = [];
   imagesArray = [];
   url = `${process.env.REACT_APP_SSS}/marketing/influencer`;

    constructor(props) {
      super(props);
      this.districtSelect = React.createRef();
      // this.locationSelect = React.createRef();
      this.typeSelect = React.createRef();

      this.state = {
        influencer_name : '',
        contact_number : '',
        whatsapp_number : '',
        dob : '',
        types : [],
        type : '',
        districts : [],
        district : '',
        locations : [],
        location : '',
        brands :[],
        selected_brand :[],
        job : "FREELANCER",
        work_outside : 'NO',
        company_name : '',
        contact_person : '',
        contact_no : '',
        work_location : '',
        ouside_locations : '',
        work_type : '',
        experience : '',
        address : '',
        rows: [{
          name : '',
          relation : '',
          age : '',
          occupation : '',
        }],
        image : '',
        file : '',
        inf_image : '',
        sid :'',
        customer_id : '',
      }
      this.formChange = this.formChange.bind(this);
    }

    componentDidMount(){  
      singleCustomer_DOM = $(".single_customer_details").clone();
      var obj_this = this;
      //get categories and brands
      const url1 = `${process.env.REACT_APP_SSS}/api/get/marketing/details`;

      $.ajax({
        url : url1,
        data : {
          sid : this.context.user_details.sid
        },
        type : "GET"
      }).done(function(return_data){
        console.log(return_data);
        // return;
        if(return_data.status == "success"){
          obj_this.setState({
            districts : return_data.districts,
            types : return_data.types,
            brands : return_data.brands,
          });
        }else{
          obj_this.context.loading(0);
          obj_this.props.history.replace("/");
        }
      }).fail(function(){
        obj_this.context.loading(0);
        alert("Network error");
      });

      $(".customer_suggestions_container").on("mousedown",".single_customer_details",function(){
        $(".customer_suggestions_container").empty().css("display","none");
        const customer_id = $(this).attr("customer_id");
        obj_this.context.loading(1);
        const url = `${process.env.REACT_APP_SSS}/api/influencer/details`;
        $.ajax({
          url : url,
          data : {
            sid : obj_this.context.user_details.sid,
            customer_id : customer_id
          },
          type : "POST"
        }).done(function(return_data){
          console.log(return_data);

          obj_this.setState({
            locations : return_data.locations,

          });
          var option = obj_this.state.districts.filter(item => item.value == return_data.influencer.district);
          var option1 = obj_this.state.locations.filter(item => item.value == return_data.influencer.location);
          var option2 = obj_this.state.types.filter(item => item.value == return_data.influencer.influencer_type);

          option = option[0]?option[0]:{};
          option1 = option1[0]?option1[0]:{};
          // return_data.influencer.dob = return_data.influencer.dob.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' });
          // console.log(new Date(return_data.influencer.dob));
          obj_this.setState({
            selected_brand : return_data.brands?return_data.brands:'',
            influencer_name : return_data.influencer.influencer_name,
            type : option2,
            contact_number : return_data.influencer.contact_no,
            whatsapp_number : return_data.influencer.whatsapp_no,
            dob : return_data.influencer.dob?new Date(return_data.influencer.dob):null,
            address : return_data.influencer.res_address,
            district : option,
            location : option1,
            job : return_data.influencer.job,
            work_location : return_data.influencer.current_work_location,
            company_name : return_data.influencer.company_name,
            contact_no : return_data.influencer.comp_contact_no,
            contact_person : return_data.influencer.contact_person,
            work_outside :  return_data.influencer.work_outside,
            ouside_locations : return_data.influencer.outside_locations,
            work_type : return_data.influencer.type_of_work,
            experience : return_data.influencer.year_of_experience,
            inf_image : return_data.influencer.image_src,
            // type : return_data.influencer.influencer_type,
            customer_id : customer_id,
          });

          // for(var i=0;i<return_data.family.length;i++){
          //   var name = return_data.family[i]['name'];
          //   var relation = return_data.family[i]['relation'];
          //   var age = return_data.family[i]['age'];
          //   var occupation = return_data.family[i]['occupation']
          //   let totalRemittanceArray = []
          //   obj_this.state.rows.push({ name, relation,age,occupation })
          // }
          // obj_this.state.rows.splice(0, 1);

          obj_this.context.loading(0);
        });
      })

      $(".name").on("focusout",function(e){
        console.log(e.target);
        $(".customer_suggestions_container").empty().css("display","none");
      });
      var overflowTimeout = setTimeout(()=>{});

      $(".products_container").on("click",".minimize_button",function(){
        var elem = $(this).parents(".single_product_container");
        elem.find(".qty_unit_price_container").css("display","grid");
        clearTimeout(overflowTimeout);
        var original_height = elem.height();
        elem.height(original_height);
        setTimeout(function(){
        elem.css({
          "height" : "46px",
          "overflow" : "hidden"
          }).find(".maximize_button").css("display","block");
        },1);
        $(this).css("display","none");
      });

      $(".products_container").on("click",".maximize_button",function(){
        var elem = $(this).parents(".single_product_container");
        elem.find(".qty_unit_price_container").css("display","none");
        elem.heightAuto().find(".minimize_button").css("display","block");
        $(this).css("display","none");
        overflowTimeout = setTimeout(function(){
          elem.css("overflow","");
        },1000);
      });
    }

    formChange(e){
      this.setState({
        [e.target.name] : e.target.value
      });
    }

    workChange(e){
      // console.log(option);
      this.setState({
        work_outside : e.target.value
      }); 
    }

    jobChange(e){
      // console.log(option);
      this.setState({
        job : e.target.value
      }); 
    }

    brandChange(option){
      console.log(option);
      this.setState({
        selected_brand : option
      }); 
    }
    onDobChange(value){
      this.setState({dob : value});
      // console.log(value);
    }
  
    districtChange(option){
      this.setState({
        dist : option.value
      });
      this.setState({
        district : option
      });
      this.context.loading(1);
      const obj_this = this;
      const url = `${process.env.REACT_APP_SSS}/api/get/locations`;
      $.ajax({
        url : url,
        data : {
          sid : this.context.user_details.sid,

          district_id : option
        },
        type : "GET"
      }).done(function(return_data){
            console.log(return_data);

        if(return_data.status == "success"){
          obj_this.setState({
            locations : return_data.locations,
          });
          obj_this.context.loading(0);
        }else{
          obj_this.context.loading(0);
          obj_this.props.history.replace("/");
        }
      }).fail(function(){
        alert("Network error");
      });
    }

    locationChange(option){
      this.setState({
        loc : option.value
      });
      this.setState({
        location : option
      });
    }

    typeChange(option){
      this.setState({
        type : option
      });
    }

    handleRemoveSpecificRow = (idx) => () => {
      // console.log(idx);
      // return;
      $(".single_product_container").css('background-color','');
      const rows = [...this.state.rows];
      rows.splice(idx, 1);
      this.setState({ 
        rows 
      });
  
    }

    handleChange = idx => e => {
      $(".single_product_container").css('background-color','');
      const { name, value } = e.target;
      const rows = [...this.state.rows];
      const row = {...rows[idx]};
      row[name] = value;
      rows[idx] = row;
      var obj_this = this;
      console.log(rows);
      this.setState({
        rows
      },() =>{
        if(e.target.name == "age" || e.target.name == "occupation" ){
          obj_this.find_total(idx)
        }
      });    
    };

    find_total(idx){
      const rows = [...this.state.rows];
      const row = {...rows[idx]};
      
      // console.log(total);
      rows[idx] = row;
      this.setState({
        rows
      });
    }

    
    handleAddRow = () => {
      $(".single_product_container").css('background-color','');
      if(!this.validateProducts(this.state.rows)){
        return;
      }
      // console.log(this.state.rows);
      $(".single_product_container:not(:last-of-type) .minimize_button").trigger("click");
      const item = {
        name : "",
        relation: "",
        age : '',
        occupation: "",
      };
      this.setState({
        rows: [...this.state.rows, item]
      });
    };

    validateProducts(items){
      console.log(items);
      if(items.length == 1){
        if(!items[0].name){
          alert("Name required");
          $(".single_product_container[index=0]").find(".maximize_button").trigger("click");
          $(".single_product_container[index=0]").find(".product").focus();
          return false;
        }
        if(!items[0].relation){
          alert("Relation required");
          $(".single_product_container[index=0]").find(".maximize_button").trigger("click");
          $(".single_product_container[index=0]").find(".product_qty").focus();
          return false;
        }
        if(!items[0].age){
          alert("Age required");
          $(".single_product_container[index=0]").find(".maximize_button").trigger("click");
          $(".single_product_container[index=0]").find(".unit_price").focus();
          return false;
        }
        if(!items[0].occupation){
          alert("Occupation required");
          $(".single_product_container[index=0]").find(".maximize_button").trigger("click");
          $(".single_product_container[index=0]").find(".unit").focus();
          return false;
        }
      }else{
        for(var i=0;i<items.length;i++){
          if(items[i].name){
            if(!items[i].relation){
              alert("Relation requuired");
              $(".single_product_container[index="+i+"]").find(".maximize_button").trigger("click");
              $(".single_product_container[index="+i+"]").find(".unit").focus();
              return false;
            }
            if(!items[i].age){
              alert("Age required");
              $(".single_product_container[index="+i+"]").find(".maximize_button").trigger("click");
              $(".single_product_container[index="+i+"]").find(".product_qty").focus();
              return false;
            }
            if(!items[i].occupation){
              alert("Occupation is required");
              $(".single_product_container[index="+i+"]").find(".maximize_button").trigger("click");
              $(".single_product_container[index="+i+"]").find(".unit_price").focus();
              return false;
            }
  
          }
        }
      }
      return true;
    }

    influencerChange(e){
      $(".customer_suggestions_container").empty();
      this.setState({
        [e.target.name] : e.target.value
      });
      
      if(!e.target.value){
        $(".customer_suggestions_container").empty().css("display","none");

        this.setState({
          type : '',
          contact_number : '',
          whatsapp_number : '',
          dob : '',
          district : '',
          location : '',
          address : '',
          selected_brand : [],
          work_location : '',
          work_type : '',
          experience : '',
          rows: [{
            name : '',
            relation : '',
            age : '',
            occupation : '',
          }],
          inf_image : '',
          customer_id : '',
        });

          return;
      }
      // alert(e.target.value);
      if(!this.state.customer_id){
        $(".customer_suggestions_container").empty().css("display","none");

        this.setState({
          type : '',
          contact_number : '',
          whatsapp_number : '',
          dob : '',
          district : '',
          location : '',
          address : '',
          selected_brand : [],
          work_location : '',
          work_type : '',
          experience : '',
          rows: [{
            name : '',
            relation : '',
            age : '',
            occupation : '',
          }],
          inf_image : '',
          customer_id : '',
        });

      }
      this.context.loading(1);
      const obj_this = this;
      const url = `${process.env.REACT_APP_SSS}/api/search/influencer/names`;
      customer_XHR.abort();
      customer_XHR = $.ajax({
        url : url,
        data : {
          sid : this.context.user_details.sid,
          influencer : e.target.value
        },
        type : "GET"
      }).done(function(return_data){
        if(return_data.influencers.length){
          for(var i=0;i<return_data.influencers.length;i++){
            var node = singleCustomer_DOM.clone();
            node.find(".customer_name").html(return_data.influencers[i]['influencer_name']);
            node.find(".customer_phone_no").html(return_data.influencers[i]['contact_no']);
            node.attr("customer_id",return_data.influencers[i]['id']);
            $(".customer_suggestions_container").append(node);
          }
          $(".customer_suggestions_container").css("display","block");
          obj_this.context.loading(0);
        }else{
          $(".customer_suggestions_container").css("display","none");
          obj_this.context.loading(0);
        }
      }); 
    }

     // image onchange hander
     uploadImage = (e) => {
      if (e.target.files && e.target.files[0]) {
        this.setState({
          file: URL.createObjectURL(e.target.files[0])
        });
      }

      this.setState({
          image: e.target.files[0]
      })
      var n = document.getElementsByClassName('inf_img'); 
      var n1 = document.getElementsByClassName('close');  
 
        $(n).css({
            'display': 'inline-block'
        });

        $(n1).css({
          'display': 'inline-block'
      });
      console.log(this.state.file);
  }

  getComponent(e) {
    var name = e.target.getAttribute('name');
    if(name) {
      const url = `${process.env.REACT_APP_SSS}/api/delete/influencer/images`;
      customer_XHR.abort();
      customer_XHR = $.ajax({
        url : url,
        data : {
          sid : this.context.user_details.sid,
          id : this.state.customer_id
        },
        type : "POST"
        }).done(function(return_data){
          if(return_data.status == "success"){
          }else{
            obj_this.context.loading(0);
          }
        });
        $(e.target).css({
          'display': 'none'
        });
        var n = document.getElementsByClassName('inf_img');  
        $(n).css({
            'display': 'none'
        });
        this.setState({
          inf_image: '',
      })
    } 
    else {
      var n = document.getElementsByClassName('inf_img');
      $(e.target).css({
        'display': 'none'
      });
        $(n).css({
            'display': 'none'
        });
        this.setState({
          image: '',
          file : ''
      })
    }

  }

    formSubmit(e){
      e.preventDefault();
      const salesorder = this.state;
      
      console.log(salesorder);
     
      
      e.preventDefault();
      var details = this.state;
      if(!details.type){
        this.typeSelect.current.focus();
        return;
      }
      if(!details.district.value){
        this.districtSelect.current.focus();
        return;
      }
      // if(!details.location.value){
      //   this.locationSelect.current.focus();
      //   return;
      // }

      var sid =  this.context.user_details.sid;
      console.log(this.fileArray);   
      var obj_this = this;
      var fd = new FormData(document.querySelector('form'));

      for (let i = 0; i < this.state.rows.length; i++) {
        fd.append("name[]", this.state.rows[i]['name']);
        fd.append("relation[]", this.state.rows[i]['relation']);
        fd.append("age[]", this.state.rows[i]['age']);
        fd.append("occupation[]", this.state.rows[i]['occupation']);
      }

      fd.append('image', this.state.image)

      fd.append('influencer_id',this.state.customer_id);

      fd.append('sid',sid);

      const url = `${process.env.REACT_APP_SSS}/api/save/marketing/influencer/details`;

      axios.post(url,fd)
      .then(res =>{
        console.log(res.data);
        if(res.data.status == "success"){
          alert("Influencer inserted.");
          obj_this.context.loading(0);
          obj_this.props.history.replace('/dashboard');
        }
        else if(res.data.status == "update"){
              alert("Influencer updated.");
              obj_this.context.loading(0);
              obj_this.props.history.replace('/dashboard');
        }
        else if(res.data.status == "already"){
          alert("Influencer exists.");
          obj_this.context.loading(0);
          obj_this.props.history.replace('/dashboard');
        }
        else {
          alert("Network Error.");
          obj_this.context.loading(0);
        }
      });
    }    

  render(){

  return (

    <MyContext.Consumer>
      {context => (
        <div className="new_marketing_influencer_container">
          <div className="page_header">
            
            <div className="page_title"><i className="fas fa-arrow-left" onClick={() => window.history.back()} style={{marginRight: '15px', cursor: 'pointer'}}></i> ADD / UPDATE INFLUENCER</div>
          </div> 
          <form className="dealer_form"
            onSubmit={e => this.formSubmit(e)} encType="multipart/form-data" 
          >
            <div className="product_details_container blocks">
            <div className="customer_container">

              <div className="input_label_head">Influencer Details</div>
                <div className="input_label">Name of Influencer *</div>
                  <input className="name input custom_input"
                    type="text"
                    name="influencer_name"
                    value={this.state.influencer_name}
                    onChange={e => this.influencerChange(e)}
                    required
                    autoComplete="off"
                  />
                     <div className="customer_suggestions_container">
                    <div className="single_customer_details">
                      <div className="customer_name"></div>
                      <div className="customer_phone_no"></div>
                  </div>
                  </div>
                  </div>
                  <div className="input_label">Influencer Type *</div>
                  <Select 
                    options={this.state.types}  
                    value ={this.state.type}
                    name = "influencer_type"
                    className="district" 
                    ref={this.typeSelect}
                    onChange={e => this.typeChange(e)}
                    required
                  />  
                <div className="input_label">Contact Number *</div>
                  <input className="name input custom_input"
                    type="tel"
                    name="contact_number"
                    pattern="^[0]?[1-9][0-9]{9}$"
                    value={this.state.contact_number}
                    onChange={this.formChange}
                    required
                    autoComplete="off"
                  />
                <div className="input_label">Whatsapp Number</div>
                  <input className="name input custom_input"
                    type="tel"
                    name="whatsapp_number"
                    pattern="^[0]?[1-9][0-9]{9}$"
                    value={this.state.whatsapp_number}
                    onChange={this.formChange}
                    // required
                    autoComplete="off"
                  />
                  <div className="input_label">Date Of Birth</div>
                <DatePicker
                  className="input custom_input transaction_date"
                  name="dob"
                  onChange={(value) => this.onDobChange(value)}
                  value={this.state.dob}
                  format="dd-MM-y"
                  maxDate = {new Date()}
                  // required
                />  
                 <div className="input_label">Residential Address *</div>
              <textarea className="input billing_address custom_input" 
                name="address"
                value={this.state.address}
                onChange={this.formChange}
                required
                autoComplete="off"
              />
              
                <div className="input_label">Wilayat *</div>
                  <Select 
                    options={this.state.districts}  
                    value ={this.state.district}
                    name = "district"
                    className="district" 
                    ref={this.districtSelect}
                    onChange={e => this.districtChange(e)}
                    required
                  />  
                <div className="input_label">Location</div>
                  <Select 
                    options={this.state.locations}  
                    value ={this.state.location}
                    name = "location"
                    className="district" 
                    // ref={this.locationSelect}
                    onChange={e => this.locationChange(e)}
                    // required
                  />     
                
            </div>


            {/* <div className="products_container blocks">
              <div className="input_label_head" 
                style={{display:"inline-block"}}
              >
                 Family Details
              </div>
              {this.state.rows.map((item, idx) => (
                <div className="single_product_container" key={idx} index={idx}>
                  <div className="product_label_and_delete_button">
                    <div className="maximize_button">
                      <i className="fa fa-plus"></i>
                    </div>
                    <div className="minimize_button">
                      <i className="fa fa-minus"></i>
                    </div>
                    <div className="product_label">
                        {this.state.rows[idx].name}
                    </div>
                    <i className="delete_product_button fa fa-trash-alt" 
                      type="button"
                      style={{visibility:this.state.rows.length >1?"visible":"hidden"}}
                      onClick={this.handleRemoveSpecificRow(idx)}
                    ></i>
                  </div>
                  <div className="qty_unit_price_container">
                    <span
                       style={{visibility:this.state.rows[idx].relation.label?"visible":"hidden"}}
                    >Qty : {this.state.rows[idx].age} {this.state.rows[idx].relation.label}</span>
                  
                   
                  </div>
                  

                  <div className="input_grid">
                    <div>
                      <div className="input_label">Name</div>
                      <input className="input specifications custom_input" 
                        type="text"
                        name="name"
                        value={this.state.rows[idx].name}
                        onChange={this.handleChange(idx)}
                        autoComplete="off"
                      />
                    </div>
                    <div>
                      <div className="input_label">Relation</div>
                      <input className="input specifications custom_input" 
                        type="text"
                        name="relation"
                        value={this.state.rows[idx].relation}
                        onChange={this.handleChange(idx)}
                        autoComplete="off"
                      />
                    </div>
                  </div> 
                  
                  <div className="input_grid">
                    <div>
                      <div className="input_label">Age</div>
                      <input className="product_qty custom_input"
                        type="number"
                        name="age"
                        value={this.state.rows[idx].age}
                        onChange={this.handleChange(idx)}
                        autoComplete="off"
                      />
                    </div>
                    <div>
                    <div className="input_label">Occupation</div>
                      <input className="unit_price input custom_input"
                        type="text"
                        name="occupation"
                        value={this.state.rows[idx].occupation}
                        onChange={this.handleChange(idx)}
                        autoComplete="off"
                      />
                    </div>
                 </div>
              </div>
              ))}
              <div className="price_and_add_button_container">
                
                <button className="add_product_button"
                  type="button"
                  style={{visibility:this.state.rows[this.state.rows.length-1].name && this.state.rows[this.state.rows.length-1].relation?"visible":"hidden"}}
                  onClick={this.handleAddRow}
                >
                  <i className="fa fa-plus"></i> Add
                </button>
              </div>
            </div> */}
          
              <div className="product_details_container blocks">
              <div className="input_label_head">Other Details</div>
              <div className="input_radio_container">
                  <span>Job : </span>
                    <div className="lead_type_radio_buttons">
                      <div className="label_radio_container">
                      <input type="radio" 
                          name="job" 
                          value="FREELANCER"  
                          checked={this.state.job == 'FREELANCER'} 
                          onChange={e => this.jobChange(e)}
                        />
                        <div>Freelancer</div>
                      </div>
                      <div className="label_radio_container">
                      <input type="radio" 
                          name="job" 
                          value="COMPANY STAFF"
                          checked={this.state.job == 'COMPANY STAFF'} 
                          onChange={e => this.jobChange(e)}
                        />
                        <div>Company Staff</div>
                      </div>
                    </div>
                </div>
                <div className="input_label" style={{display:this.state.job == 'FREELANCER'?"none":"block"}}>Company Name</div>
                  <input className="name input custom_input"
                    type="text"
                    name="company_name"
                    value={this.state.company_name}
                    onChange={this.formChange}
                    autoComplete="off"
                    style={{display:this.state.job == 'FREELANCER'?"none":"block"}}
                  />
                <div className="input_label"  style={{display:this.state.job == 'FREELANCER'?"none":"block"}}>Contact Person</div>
                  <input className="name input custom_input"
                    type="text"
                    name="contact_person"
                    value={this.state.contact_person}
                    onChange={this.formChange}
                    autoComplete="off"
                    style={{display:this.state.job == 'FREELANCER'?"none":"block"}}
                  />
                  <div className="input_label"  style={{display:this.state.job == 'FREELANCER'?"none":"block"}}>Contact Number</div>
                  <input className="name input custom_input"
                    type="tel"
                    name="contact_no"
                    pattern="^[0]?[1-9][0-9]{9}$"
                    value={this.state.contact_no}
                    onChange={this.formChange}
                    autoComplete="off"
                    style={{display:this.state.job == 'FREELANCER'?"none":"block"}}
                  />
                  <div className="input_label">Current Work Location</div>
                  <input className="name input custom_input"
                    type="text"
                    name="work_location"
                    value={this.state.work_location}
                    onChange={this.formChange}
                    // required
                    autoComplete="off"
                  />
                   <div className="input_radio_container">
                  <span>Work Outside : </span>
                    <div className="lead_type_radio_buttons">
                      <div className="label_radio_container">
                      <input type="radio" 
                          name="work_outside" 
                          value="YES"  
                          checked={this.state.work_outside == 'YES'} 
                          onChange={e => this.workChange(e)}
                        />
                        <div>Yes</div>
                      </div>
                      <div className="label_radio_container">
                      <input type="radio" 
                          name="work_outside" 
                          value="NO"
                          checked={this.state.work_outside == 'NO'} 
                          onChange={e => this.workChange(e)}
                        />
                        <div>No</div>
                      </div>
                    </div>
                </div>
                <div className="input_label" style={{display:this.state.work_outside == 'NO'?"none":"block"}}>Outside Locations *</div>
              <textarea className="input billing_address custom_input" 
                name="ouside_locations"
                value={this.state.ouside_locations}
                onChange={this.formChange}
                required={this.state.work_outside=="YES"}
                autoComplete="off"
                style={{display:this.state.work_outside == 'NO'?"none":"block"}}

              />
            
                  <div className="input_label">Type Of Work</div>
                  <input className="name input custom_input"
                    type="text"
                    name="work_type"
                    value={this.state.work_type}
                    onChange={this.formChange}
                    // required
                    autoComplete="off"
                  />
                    <div className="input_label">Year Of Experience</div>
                  <input className="name input custom_input"
                    type="number"
                    name="experience"
                    value={this.state.experience}
                    onChange={this.formChange}
                    // required
                    autoComplete="off"
                  />
              <div className="input_label">Commonly Dealing Brands</div>
                <Select 
                  options={this.state.brands}  
                  value ={this.state.selected_brand}
                  isMulti={true}
                  name="brands[]"
                  // ref={this.categorySelect}
                  onChange={e => this.brandChange(e)}
                  // required
                />  
                             {this.state.customer_id?
<span>
            <span className="form-group multi-preview" style={{marginTop: '10px',display:this.state.inf_image?"block":"none"}}>

            
            <span className="thumbnail">

            <img src={`${this.url}/${this.state.inf_image}`} className="inf_img" name="inf_img"/>
            <a>  <i className="close far fa-times-circle" name="iclose"  onClick={(e) => this.getComponent(e)} > </i></a>

            </span>

    
      </span>
         <span className="form-group multi-preview" style={{marginTop: '10px',display:this.state.file?"block":"none"}}>

            
         <span className="thumbnail">

         <img src={this.state.file} className="inf_img"/>
         <a>  <i className="close far fa-times-circle" onClick={(e) => this.getComponent(e)} > </i></a>

         </span>

 
   </span>
   </span>   
:
               

            <span className="form-group multi-preview" style={{marginTop: '10px',display:this.state.file?"block":"none"}}>

            
                <span className="thumbnail">

                <img src={this.state.file} className="inf_img"/>
                <a>  <i className="close far fa-times-circle" onClick={(e) => this.getComponent(e)} > </i></a>

                </span>

        
          </span>
                
        }
              <div className="input_label">Upload Photo</div>
                <input className="file_upload"
                  type="file"
                  name="image"
                  id="files"
                  onChange={this.uploadImage}
                  autoComplete="off"
                  disabled={this.state.image||this.state.inf_image}

                />
                
              </div>
              <button type="submit" className="submit_button"><i className="far fa-save"></i> Save</button>
            </form>           
        </div>
      )}
    </MyContext.Consumer>
  )}
}

export default Influencer;
Influencer.contextType = MyContext;
